import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaBitcoin,
  FaEthereum,
  FaCoins
} from "react-icons/fa";

import {
  SiTether
} from "react-icons/si";

import "./CryptoSelection.css";
import { Helmet } from "react-helmet-async";

function CryptoSelection() {
  const navigate = useNavigate();

  const coins = [
    {
      name: "USDT (TRC20)",
      slug: "usdt",
      icon: <SiTether />
    },
    {
      name: "Bitcoin",
      slug: "bitcoin",
      icon: <FaBitcoin />
    },
    {
      name: "Ethereum",
      slug: "ethereum",
      icon: <FaEthereum />
    },
    {
      name: "USD Coin",
      slug: "usdc",
      icon: <FaCoins />
    }
  ];

  return (

    <>
     <Helmet>
            <title>Bank Transfer Payment</title>
            <link rel="canonical" href="https://kamagrastar.eu/crypto-selection" />
          </Helmet>
    <div className="crypto-page">
      <div className="crypto-container">
        <h1>Select Cryptocurrency</h1>

        <p>
          Choose your preferred cryptocurrency
          to complete payment.
        </p>

        <div className="crypto-grid">
          {coins.map((coin) => (
            <div
              key={coin.slug}
              className="crypto-card"
              onClick={() =>
                navigate(`/checkout/crypto-payment/${coin.slug}`)
              }
            >
              <div className="crypto-icon">
                {coin.icon}
              </div>

              <h3>{coin.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
}

export default CryptoSelection;